var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Light",
    opacity: 0.2,
    d: "M1.5 5.45703C1.5 3.80018 2.84315 2.45703 4.5 2.45703H13.5C15.1569 2.45703 16.5 3.80018 16.5 5.45703V12.957C16.5 14.6139 15.1569 15.957 13.5 15.957H4.5C2.84315 15.957 1.5 14.6139 1.5 12.957V5.45703Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dark",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03203 5.89507C4.20435 5.63659 4.55359 5.56674 4.81208 5.73906L7.64798 7.62966C8.46673 8.1755 9.53339 8.1755 10.3521 7.62966L13.188 5.73906C13.4465 5.56674 13.7958 5.63659 13.9681 5.89507C14.1404 6.15356 14.0706 6.5028 13.8121 6.67512L10.9762 8.56572C9.77954 9.36348 8.22058 9.36348 7.02394 8.56572L4.18804 6.67512C3.92956 6.5028 3.85971 6.15356 4.03203 5.89507Z",
    fill: "#6B47F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2dc79f9486d825d6faeb700ac01cd326.svg";
export { ForwardRef as ReactComponent };